module.exports = __webpack_public_path__ + "files/3b4b79b4102312c6184187ca3abe087a.png";